import { RESERVATIONS_INITIAL_STATE } from "../pages/Dashboard/initialState";
import { SIDEBAR_INITIAL_STATE } from "../pages/Dashboard/initialState";

const INITIAL_STATE = {
	reservations: RESERVATIONS_INITIAL_STATE,
	sidebar: SIDEBAR_INITIAL_STATE
};
export default INITIAL_STATE;
